module.exports = __webpack_public_path__ + "3bd3407e1d83a81a2e6b94f95899cf86.svg";